import React, { useState } from 'react';
import AssetTags from './AssetTags';
import TagDetailsModal from '../../pages/Assets/Tags/modal/TagDetailsModal/TagDetailsModal';

interface Asset {
  id: number;
  name: string;
}

interface AssetTagsWithDetailsModalProps {
  assets: Asset[];
  maxVisible?: number;
  className?: string;
  showEllipsis?: boolean;
  tagId?: number;
  onEditOpen?: () => void;
}

const AssetTagsWithDetailsModal: React.FC<AssetTagsWithDetailsModalProps> = ({
  assets,
  maxVisible = 4,
  className = '',
  showEllipsis = true,
  tagId,
  onEditOpen,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleShowMoreClick = (): void => {
    setIsModalOpen(true);
  };

  const handleCloseModal = (): void => {
    setIsModalOpen(false);
  };

  const handleOpenModal = (): void => {
    setIsModalOpen(true);
  };

  const handleEditOpen = (): void => {
    setIsModalOpen(false);
    if (onEditOpen) {
      onEditOpen();
    }
  };

  return (
    <>
      <AssetTags
        assets={assets}
        maxVisible={maxVisible}
        className={className}
        showEllipsis={showEllipsis}
        onShowMoreClick={handleShowMoreClick}
      />
      <TagDetailsModal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        handleOpen={handleOpenModal}
        tagId={tagId}
        handleEditOpen={handleEditOpen}
      />
    </>
  );
};

export default AssetTagsWithDetailsModal;
